import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-sm',
  templateUrl: './loading-sm.component.html',
  styleUrls: ['./loading-sm.component.css']
})
export class LoadingSmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/loading-sm/loading-sm.component.ts